import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import TurnstileWidget from '../../src/components/TurnstileWidget';
import { TURNSTILE_SITE_KEY } from '../../src/config';
import { saveTurnstileTokenForAction } from '../../src/utils/turnstileFlow';

export default function HumanVerificationPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState('');
  const [resetKey, setResetKey] = useState(0);

  const nextPath = useMemo(() => {
    const candidate = String(location.state?.nextPath || '/login').trim();
    if (!candidate.startsWith('/')) return '/login';
    return candidate;
  }, [location.state?.nextPath]);

  const requiredAction = useMemo(() => {
    const candidate = String(location.state?.requiredAction || '').trim();
    return candidate || 'login_start';
  }, [location.state?.requiredAction]);

  const resumeState = location.state?.resumeState || null;

  useEffect(() => {
    if (!TURNSTILE_SITE_KEY) {
      navigate(nextPath, { replace: true, state: resumeState });
    }
  }, [navigate, nextPath, resumeState]);

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: '#ffffff',
        padding: '24px',
        fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, sans-serif',
      }}
    >
      <section
        style={{
          width: '100%',
          maxWidth: '460px',
          border: '1px solid #e2e8f0',
          borderRadius: '18px',
          padding: '26px 22px',
          textAlign: 'center',
          background: '#fff',
        }}
      >
        <h1 style={{ margin: 0, fontSize: '24px', fontWeight: 600, color: '#111827' }}>Security Check</h1>
        <p style={{ margin: '10px 0 0', color: '#4b5563', fontSize: '14px', lineHeight: 1.5 }}>
          Verify you are human to continue.
        </p>

        <div style={{ marginTop: '18px', display: 'flex', justifyContent: 'center' }}>
          <TurnstileWidget
            siteKey={TURNSTILE_SITE_KEY}
            action={requiredAction}
            resetKey={resetKey}
            onTokenChange={(token) => {
              if (!token) {
                return;
              }
              saveTurnstileTokenForAction(requiredAction, token);
              navigate(nextPath, { replace: true, state: resumeState });
            }}
          />
        </div>

        {error ? <p style={{ marginTop: '10px', color: '#b91c1c', fontSize: '13px' }}>{error}</p> : null}

        <button
          type="button"
          onClick={() => {
            setError('Reloaded challenge. Please verify again.');
            setResetKey((prev) => prev + 1);
          }}
          style={{
            marginTop: '14px',
            border: '1px solid #d1d5db',
            background: '#fff',
            color: '#111827',
            borderRadius: '999px',
            padding: '8px 14px',
            cursor: 'pointer',
            fontWeight: 500,
          }}
        >
          Reload Verification
        </button>
      </section>
    </main>
  );
}
